export const at = (array: unknown[], index: number) => {
    // Polyfill for array.at()
    if (array.at) return array.at(index);
    if (index > 0 && index < array.length) return array[index];
    else {
        const i = index < 0 ? array.length + index : index;
        if (i >= 0 && i < array.length) return array[i];
    }
    return undefined;
};

export const shuffle = (array: unknown[]) =>
    array
        .map((a) => ({ sort: Math.random(), value: a }))
        .sort((a, b) => a.sort - b.sort)
        .map((a) => a.value);

export const findLast = <T>(array: T[], predicate: (value: T) => boolean) => {
    for (let i = array.length - 1; i >= 0; i--) {
        if (predicate(array[i])) {
            return array[i];
        }
    }
    return undefined;
};
